/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { AttachmentVO } from '@well/attachment/domain';

export class ComplaintAttachmentDtoModel extends AttachmentVO {

  complaintUuid: string | undefined = undefined;

  validFrom: string | undefined = undefined;

  validTo: string | undefined = undefined;

  description: string | undefined = undefined;
}
